export default "__VITE_ASSET__D$ZJMi2K__"